import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Set } from 'immutable';
import { Popup } from 'react-mapbox-gl';

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
};

class DisplayFeatures extends Component {
  static contextTypes = {
    map: PropTypes.object.isRequired,
  };

  state = {
    coordinates: null,
    hoveredFeatures: [],
  };

  componentDidMount() {
    this.context.map.on('mousemove', this.onMouseMove);
    this.context.map.on('mouseout', this.onBlur);
  }

  componentWillUnmount() {
    this.context.map.off('mousemove', this.onMouseMove);
    this.context.map.off('mouseout', this.onBlur);
  }

  onBlur = () => {
    this.setState({
      hoveredFeatures: [],
    });
  };

  onMouseMove = (event) => {
    const { lng, lat } = event.lngLat;
    this.setState({
      coordinates: [lng, lat],
      hoveredFeatures: this.context.map.queryRenderedFeatures(event.point),
    });
  };

  get featureProperties() {
    const strings = this.state.hoveredFeatures
      .map(feature => JSON.stringify(feature.properties))
      .sort();

    return Set(strings).map(props => <div key={props}>{props}</div>);
  }

  render() {
    if (!this.state.coordinates || !this.state.hoveredFeatures.length) return null;

    return (
      <Popup
        coordinates={this.state.coordinates}
      >
        <div style={styles.container}>
          {this.featureProperties}
        </div>
      </Popup>
    );
  }
}

export default DisplayFeatures;



// WEBPACK FOOTER //
// ./src/display-features.js